const Dispatcher = require("flux/lib/Dispatcher");
import assign from 'lodash/assign'


var AppDispatcher = assign(new Dispatcher(), {
	/**
	 * This function is a bridge between the components/views and the dispatcher.
	 * Actions will be marked as a 'VIEW_ACTION'. Other sources of actions could be
	 * 'SERVER_ACTION'. This method helps distinguish between view triggered actions and server-side actions
	 * @param {object} action The data being parsed from the view/component that triggered the action.
	 */
	handleViewAction: function(action) {
		this.dispatch({
			source: 'VIEW_ACTION',
			action: action
		});
	},
	/**
	 * Equivelent to the above function but for server actions
	 */
	handleServerAction: function(action) {
		this.dispatch({
			source: 'SERVER_ACTION',
			action: action
		});
	}
});

export default AppDispatcher;
